module.exports = __webpack_public_path__ + "media/director_meetings/status_local-f50b6731.png";